/** Мелкая логика персональной доски, вынесенная без React (E18). */

/** Ключ проекта из ключа задачи `DEMO-12` — для панели задачи. */
export function projectKeyOfIssue(issueKey: string): string {
  const dash = issueKey.lastIndexOf('-');
  return dash > 0 ? issueKey.slice(0, dash) : '';
}

/** Следующая порция колонок: по 50 задач, но не больше лимита API. */
export const COLUMN_LIMIT_STEP = 50;
export const COLUMN_LIMIT_MAX = 200;

export function nextColumnLimit(current: number): number {
  return Math.min(current + COLUMN_LIMIT_STEP, COLUMN_LIMIT_MAX);
}
